import {
  Avatar,
  Box,
  Flex,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import ArabiaShow from "../svgs/ArabiaShow";
import CustomText from "../components/text/CustomText";
import { IconChevronDown, IconLogout } from "@tabler/icons-react";
import { useDispatch, useSelector } from "react-redux";
import { getLoginData } from "../redux/actions/auth.actions";

function DashboardLayout() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { uid, user } = useSelector((state: any) => state.authUser);

  useEffect(() => {
    if (!uid) {
      navigate("/auth/login");
    }
    dispatch(getLoginData(uid));
    // eslint-disable-next-line
  }, [uid]);

  return (
    <Flex flexDir="column">
      <Flex align="center" bg="#fff">
        <Flex
          borderRight="1px solid"
          borderColor="yess.border"
          p="20px 48px 20px 24px"
          h="88px"
        >
          <ArabiaShow />
        </Flex>
        <Flex justify="space-between" align="center" p="24px" w="100%">
          <CustomText
            text="Visitor Dashboard"
            size="20px"
            weight="700"
            color="yess.base_black"
          />
          <Box pos="relative">
            <Flex
              gap="8px"
              align="center"
              cursor="pointer"
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
              }}
            >
              {!user ? (
                <SkeletonCircle size="40px" borderRadius="8px" />
              ) : (
                <Avatar
                  src={user?.profileImg}
                  name={user?.personalInfo?.name}
                  bg="yess.secondary_gold"
                  boxSize="40px"
                  borderRadius="8px"
                />
              )}
              <Flex flexDir="column">
                {!user ? (
                  <SkeletonText noOfLines={1} w="120px" />
                ) : (
                  <CustomText
                    text={user?.personalInfo?.name}
                    color="yess.base_black"
                  />
                )}
                {!user ? (
                  <SkeletonText noOfLines={1} w="120px" />
                ) : (
                  <CustomText
                    text={user?.personalInfo?.email}
                    color="yess.neutral500"
                    size="14px"
                  />
                )}
              </Flex>
              <IconChevronDown color="#292D32" size="20px" />
            </Flex>
            <Flex
              bg="#f2f2f2"
              p="16px 24px"
              borderRadius="12px"
              gap="12px"
              align="center"
              pos="absolute"
              w="100%"
              mt="5px"
              display={isMenuOpen ? "flex" : "none"}
              cursor="pointer"
              onClick={() => {
                navigate("/auth/login");
                localStorage.clear();
              }}
            >
              <IconLogout color="#292D32" size="20px" />
              <CustomText text="Logout" color="yess.error" cursor="pointer" />
            </Flex>
          </Box>
        </Flex>
      </Flex>
      <Box bg="#F5F5F5" p="24px" overflowY="auto" minH="100vh">
        <Outlet />
      </Box>
    </Flex>
  );
}

export default DashboardLayout;
